import mergeClasses from 'shared/lib/utils';
import { projectStatus } from '@/enteties/project/lib/project-status';
import { TooltipWrapper } from 'shared/ui/tooltips';
import type { ProjectStatus } from '@/enteties/project/modal';
import { type ModelInferenceStatus } from '@/enteties/models-inference/model';
import * as m from '@paraglide/messages';
import { Info } from 'lucide-react';
interface StatusChipProps {
  status: ProjectStatus | ModelInferenceStatus;
  withDefaultTooltip?: boolean;
}
export function StatusChip({
  status,
  withDefaultTooltip = true
}: StatusChipProps) {
  const chipContent = <div className={mergeClasses('h-[22px] rounded-[0.625rem] px-2 border inline-flex items-center justify-center gap-1.5', projectStatus[status]?.color)}>
      <p className="align-middle text-body3 line-clamp-1">
        {projectStatus[status]?.message}
      </p>
      <Info className="size-3.5 shrink-0" />
    </div>;
  if (!withDefaultTooltip) {
    return chipContent;
  }
  return <TooltipWrapper content={projectStatus[status]?.hint ?? m.project_status_default_hint()} data-sentry-element="TooltipWrapper" data-sentry-component="StatusChip" data-sentry-source-file="status-chip.tsx">
      {chipContent}
    </TooltipWrapper>;
}